import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { ToastService } from './toast.service';
import * as fromActions from '../store/actions';
import { environment } from '../../../environments/environment';
import { PlatformService } from './platform.service';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(
    private toastService: ToastService,
    private router: Router,
    private store: Store<any>,
    @Inject(DOCUMENT) private document: Document,
    private platformService: PlatformService,
    private analyticsService: AnalyticsService,
    private gtmService: GoogleTagManagerService,
  ) {}

  setPreviousUrl() {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationStart))
      .subscribe((nav: NavigationStart) => {
        const payload = { url: nav.url };
        this.document.body.classList.remove('full-screen');
        this.store.dispatch(fromActions.SetPrevUrl(payload));
        this.toastService.dismiss();
        this.lockPortrait();
      });
  }

  initGA() {
    this.setGAKey();
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setGA(event.urlAfterRedirects);

        if (environment.production) {
          this.setGTA(event.urlAfterRedirects);
        }

        this.analyticsService.trackScreen(event.urlAfterRedirects);
      }
    });
  }

  private setGTA(url) {
    const gtmTag = {
      event: 'page',
      pageName: url,
    };

    this.gtmService.pushTag(gtmTag);
  }

  private setGA(url) {
    (<any>window).ga('set', 'page', url);
    (<any>window).ga('send', 'pageview');
  }

  private setGAKey() {
    (<any>window).ga('create', environment.gaKey, 'auto');
  }

  private lockPortrait() {
    if (this.platformService.isCordova()) {
      ScreenOrientation.lock({ orientation: 'portrait' });
    }
  }
}
